export default {
  ACCOUNT: 'A',
  BREED: 'B',
  SUPPLY_CHAIN: 'S'
}
